import { WAIT_AFTER_REVOKE_TOKEN_API_CALL } from 'constants/AppConstants';
import * as notificationAction from 'features/NotificationsPopup/Notifications.action';
import { store } from 'store/ConfigureStore';
import {
  getAuthToken,
  getAuthIdToken,
  isShareToken,
  redirectToOkta,
  signOutGuestToSignIn,
  signOutUser,
  wait,
} from 'utils/app.utils';

/**
 * Sign out user or redirect to Okta.
 * If token has tokenType SHARE (guest), clear storage and redirect to /signin?redirect=... #genai
 */
const logOut = async () => {
  const subRoute = window.location.pathname + window.location.search;
  const accessToken = getAuthToken();

  store.dispatch(notificationAction.revokeAccessToken());
  await wait(WAIT_AFTER_REVOKE_TOKEN_API_CALL);

  if (getAuthIdToken()) {
    signOutUser();
  } else if (accessToken && isShareToken(accessToken)) {
    signOutGuestToSignIn(subRoute);
  } else {
    redirectToOkta(subRoute);
  }
};

window.logOut = logOut;

export default logOut;
